export interface NpsInterface {
    booking_appointment: string;
    booking_not_show?: string;
    booking_show: string;
    evaluation_done: string;
    evaluation_start?: number;
    paid_appointment: number;
    register_patient?: number;
    sr_done?: string;
    sr_start: number;
    verify_patient: number;
}

export class NpsMockup {
    evaluation_start? = 72;
    evaluation_done = 5;
    sr_start = 54;
    sr_done? = 14;
    booking_appointment = 8;
    booking_show = 3;
    appointment_completed = 2;
    appointment_paid = 3;
    booking_not_show = 5;
    register_patient? = 72;
    verify_patient = 70;
    paid_appointment = 0;
    starter_completed = 3;
    starter_paid = 3;
}
